<div class="something">
  <div>
    <img src="/assets/upload-file.svg" alt="" />
    <div>{{ text }}</div>
    <button (click)="handleClick()">+ Add products</button>
  </div>
</div>
